import { Tag, Tooltip } from 'antd';

/**
 * 经营范围匹配度展示。
 *
 * 【为什么单独抽出来】
 * 这个判断有两个页面用（发票详情、校验报告），各写一遍迟早会不一致。
 *
 * 【为什么不能只看 scopeMatched】
 * `scopeMatched === true` 有两种截然不同的来源：
 *   1. 真的比对过，且匹配上了（confidence > 0）
 *   2. **根本没有可比对的开票项目**（OCR 没识别出明细，或经营范围为空），
 *      此时后端按「无法判断不阻断」返回 matched=true、confidence=0
 * 直接显示「匹配」会把第 2 种情况说成"已核对且合规"——而实际上
 * 一个字都没比对。财务看到「匹配 0%」这种自相矛盾的展示，
 * 要么以为系统坏了，要么以为这张票有问题，两种都是误导。
 * 因此 confidence 为 0 时显示「未比对」，并把原因说清楚。
 */
export interface ScopeMatchTagProps {
  /** 匹配置信度 0-100；null 表示未执行比对 */
  confidence: number | null | undefined;
  /** 后端给出的匹配结论 */
  matched: boolean | null | undefined;
}

export function ScopeMatchTag({ confidence, matched }: ScopeMatchTagProps) {
  if (confidence === null || confidence === undefined) {
    return <span style={{ color: 'rgba(0,0,0,0.45)' }}>未比对</span>;
  }

  // 置信度为 0 说明没有可比对的依据，而不是"比对后认为不匹配"
  if (confidence === 0) {
    return (
      <Tooltip title="OCR 未识别出发票明细行，或供应商经营范围为空，因此没有可比对的内容。系统不做判断，也不因此标记风险。">
        <Tag>未比对</Tag>
      </Tooltip>
    );
  }

  return (
    <>
      <Tag color={matched ? 'green' : 'orange'}>{matched ? '匹配' : '超范围'}</Tag>
      <span className="ilc-num">{confidence}%</span>
    </>
  );
}

export default ScopeMatchTag;
